import type * as React from "react";

import { sanitizeHtml } from "./sanitize-html";

interface SanitizedTagProps {
  html: string | null | undefined;
  className?: string;
  tag?: keyof JSX.IntrinsicElements;
}

const SanitizedTag: React.FC<SanitizedTagProps> = ({
  html,
  className,
  tag,
}: SanitizedTagProps) => {
  const Component = tag || "div";

  return (
    // eslint-disable-next-line react/no-danger
    <Component
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
    />
  );
};

export default SanitizedTag;
